import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Toponym } from '../../../models/toponym.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { ToponymService } from '../../../services/toponym/toponym.service';

@Component({
  selector: 'app-toponym',
  templateUrl: './toponym.component.html',
  styleUrls: ['./toponym.component.css'],
  providers: []
})

export class ToponymComponent implements OnInit {
  selectedToponym: Toponym = null;
  toponymListTitles: DataTableField[];
  modalTitle = '';
  labels = {}

  constructor(
    public srvToponym: ToponymService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {
    this.translate.get(['toponymList']).subscribe((res) => {
      console.log(res);
      this.toponymListTitles = [
        { id: 'id', label: '#' },
        { id: 'name', label: res.toponymList.name },
      ];
    });
  }

  ngOnInit() {

    this.translate.get([
      'toponymList.add_title',
      'toponymList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['toponymList.add_title'];
      this.labels['edit_title'] = res['toponymList.edit_title'];
    });

    this.srvToponym.getAll().subscribe();
  }

  refresh () {
    this.srvToponym.getAll().subscribe();
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvToponym.toponymEditing = data == null ? new Toponym() : data;
  }

  delete(record): void {
    this.srvToponym.delete(record).subscribe();
    this.refresh();
  }

  toponymAdded($event): void {
    this.srvToponym.post($event).subscribe(() => {
      this.srvDataTable.get('dt_toponym').showDetail = false;
      this.srvToponym.toponymEditing = null;
      this.refresh();
    });
  }

  toponymUpdated($event): void {
    this.srvToponym.put($event).subscribe(() => {
      this.srvDataTable.get('dt_toponym').showDetail = false;
      this.srvToponym.toponymEditing = null;
      this.refresh();
    });
  }

  closeAddDialog() {
    this.modalTitle = '';
    this.srvToponym.toponymEditing = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/toponym/toponym.component.ts